import { AppBar, Box, Theme, Toolbar, Typography } from '@mui/material';
import { app_icon_data, qr_code_data, TRANSPARENT_PIXEL } from 'components/quote/data_uris';
import { timeout, toDataUrl } from 'helpers';
import domtoimage from 'dom-to-image';
import App from 'AppInterface/App';
import { cloneWithoutShareVideos, includeInShareImage } from './shareImageFilter';

const classes = {
	plainAppBar: (theme: Theme) => ({
		borderTop: `8px solid ${theme.palette.primary.main}`,
		borderBottom: `1px solid lightgrey`,
		backgroundColor: 'white',
		// boxShadow: 'none',
		color: 'inherit',

		'& .MuiIconButton-root': {
			color: 'rgba(0, 0, 0, 0.54)',
		},
	}),
};

export const ShareTop = (props: { subtitle?: string }) => {
	return (
		<AppBar elevation={4} sx={classes.plainAppBar} style={{ position: 'relative', display: 'flex', flexDirection: 'row', height: 88 }}>
			<img style={{ width: 80, height: 80 }} src={app_icon_data} />
			<Toolbar style={{ alignSelf: 'center', flexGrow: 1, justifyContent: 'center', textAlign: 'center', minHeight: 56, paddingTop: 0 }}>
				<Box>
					<Typography variant="h6" noWrap>
						Shri Anandpur Satsang
					</Typography>
					{props.subtitle ? (
						<Typography variant="body2" noWrap>
							{props.subtitle}
						</Typography>
					) : null}
				</Box>
			</Toolbar>
			<img style={{ width: 80, height: 80, padding: 4 }} src={qr_code_data} />
		</AppBar>
	);
};

export const ShareBottom = (props: { locale: string }) => {
	let { locale } = props;

	return (
		<AppBar
			elevation={4}
			sx={classes.plainAppBar}
			style={{
				position: 'relative',
				transform: 'scaleY(-1)',
				boxShadow: 'none',
			}}
		>
			<Toolbar style={{ transform: 'scaleY(-1)', display: 'flex', flexDirection: 'row', padding: 0, minHeight: 56 }}>
				<Box sx={{ margin: 0.5, textAlign: 'center', flexGrow: 1 }}>
					<Typography variant="h6" noWrap className={'locale-' + locale}>
						{locale === 'hi' ? 'जय सच्चिदानन्द जी' : 'Jai Sacchidanand Ji'}
					</Typography>
					<Typography variant="subtitle2" noWrap>
						App available for Android and iOS
					</Typography>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export const refToDataUrl = async (ref: React.RefObject<HTMLElement>) => {
	let measurement: HTMLDivElement | undefined;
	try {
		await timeout(500);
		let el = ref.current as HTMLElement;
		if (el) {
			if (el.querySelector('video')) {
				const clone = cloneWithoutShareVideos(el);
				clone.style.width = el.offsetWidth + 'px';
				clone.style.height = 'auto';
				clone.style.position = 'static';
				measurement = document.createElement('div');
				measurement.setAttribute('aria-hidden', 'true');
				measurement.style.cssText = 'position:fixed;left:-100000px;top:0;pointer-events:none';
				measurement.appendChild(clone);
				document.body.appendChild(measurement);
				el = clone;
			}
			const scale = 2;

			const style = {
				transform: 'scale(' + scale + ')',
				transformOrigin: 'top left',
				width: el.offsetWidth + 'px',
				height: el.offsetHeight + 'px',
			};

			const param = {
				height: el.offsetHeight * scale,
				width: el.offsetWidth * scale,
				style,
				imagePlaceholder: TRANSPARENT_PIXEL,
				filter: includeInShareImage,
			};

			let dataUrl = await domtoimage.toPng(el, param);

			return dataUrl;
		}
	} catch (err) {
		console.error(err);
	} finally {
		measurement?.remove();
	}
};

export const onShare = async (setState: any, ref: React.RefObject<HTMLElement>, shareTitle: string, imageLink?: string) => {
	let dataUrl;
	if (imageLink) {
		dataUrl = await toDataUrl(imageLink);
	} else {
		await new Promise<void>((resolve) => {
			setState({ forShare: true }, () => {
				resolve();
			});
		});

		dataUrl = await refToDataUrl(ref);

		await new Promise<void>((resolve) => {
			setState({ forShare: false }, () => {
				resolve();
			});
		});
	}

	if (dataUrl) {
		App.shareImageDataURI(shareTitle, dataUrl, 'https://www.shrianandpur.org');
	}
};
